import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const ProductosCard = ({ renglones }) => {
  const totalProductos = renglones.length;
  const total = renglones.reduce((sum, item) => 
    sum + (item.cantidad * parseFloat(item.precio || 0)), 0
  ).toFixed(0);

  return (
    <Paper
      sx={{
        p: 1,
        bgcolor: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <ShoppingCartIcon sx={{ fontSize: 16, color: "#757575" }} />
          <Typography variant="caption" fontWeight="bold" color="text.secondary">
            PRODUCTOS ({totalProductos})
          </Typography>
        </Box>
      </Box>

      {/* Lista completa de productos */}
      <Box sx={{ 
        flexGrow: 1,
        maxHeight: 80,
        overflowY: "auto",
        pr: 0.5,
        '&::-webkit-scrollbar': {
          width: 4,
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: 2,
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#bdbdbd',
          borderRadius: 2,
        }
      }}>
        {renglones.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 0.3,
              fontSize: '0.75rem',
              borderBottom: index < renglones.length - 1 ? "1px dashed" : "none",
              borderColor: "#e0e0e0",
            }}
          >
            <Typography variant="caption" fontWeight="medium" sx={{ minWidth: 20 }}>
              {item.cantidad}x
            </Typography>
            
            <Typography 
              variant="caption" 
              sx={{ 
                flex: 1, 
                ml: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {item.abreviatura || item.nombre}
            </Typography>
            
            <Typography 
              variant="caption" 
              fontWeight="medium" 
              color="primary" 
              sx={{ 
                ml: 0.5,
                textAlign: 'right',
                minWidth: 40
              }}
            >
              ${parseFloat(item.precio || 0).toFixed(0)}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Total en la parte inferior */}
      {totalProductos > 0 && (
        <Box 
          sx={{ 
            mt: 0.5,
            pt: 0.5, 
            borderTop: '1px solid #e0e0e0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="caption" color="text.secondary" fontWeight="medium">
            Total:
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="primary">
            ${total}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default ProductosCard;